// extracted by mini-css-extract-plugin
module.exports = {"container":"InputWithLabels_container__LrlW_","labels":"InputWithLabels_labels__x0sSG"};